
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.5 4.32a4.25 4.25 0 00-2.75 1.01v7.19a5.75 5.75 0 016.775.944 4.25 4.25 0 005.725.206V6.479a5.75 5.75 0 01-6.775-.943A4.25 4.25 0 008.5 4.32zm10.261-.031a.747.747 0 00-.286.175 4.25 4.25 0 01-5.95 0 5.75 5.75 0 00-8.05 0A.747.747 0 004.25 5v16a.75.75 0 001.5 0v-6.67a4.25 4.25 0 015.725.206 5.75 5.75 0 008.088-.04.746.746 0 00.187-.496V5a.749.749 0 00-.989-.711z"}})])
          )
        }
      }
    